import dayjs from 'dayjs';
import { selectorFamily } from 'recoil';
import * as vodaLend from '../api/vodaLend';
import { advanceFiguresAtom } from './advanceFigures';

const fetchStateAdvanceRepayment = async (applicationId) => await vodaLend.getAdvanceRepayment(applicationId);

export const btaTransactionHistory = selectorFamily({
  key: 'btaTransactionHistory',
  get: (applicationId) => async () => {

    const data = await fetchStateAdvanceRepayment(applicationId) || { records: [], total: {} };

    return {
      records: data.records.map((d) => ({
        displayDate: d.dueDate ? dayjs(d.dueDate).format('DD-MMM-YY') : '',
        capital: d.principalAmount,
        cost: d.costAmount,
        paymentAmount: d.paymentAmount,
        repaymentState: d.repaymentState,
        paidAmount: d.paidAmount,
        arrears: d.arrearsAmount,
        earlySettlement: d.earlySettlement,
        paidDate: d.paidDate ? dayjs(d.paidDate).format('DD-MMM-YY') : ''
      })),
      total: {
        capital: data.total?.principalAmount,
        cost: data.total?.costAmount,
        paymentAmount: data.total?.paymentAmount,
        paidAmount: data.total?.paidAmount,
        arrears: data.total?.arrearsAmount,
        earlySettlement: data.total?.earlySettlement
      }
    };
  }
});

export const btaAccountSummary = selectorFamily({
  key: 'btaAccountSummary',
  get: (applicationId) => ({ get }) => {

    const d = get(advanceFiguresAtom(applicationId));

    return d;
  }
});